/**
 * React Query keys of the hub's lists, in one place so a write in one section can invalidate the
 * lists of another (sharing a project from the projects section refreshes the team's project chips).
 */
export const AGENCY_HUB_TEAM_QUERY = 'agency-hub-team';
export const AGENCY_HUB_PROJECTS_QUERY = 'agency-hub-projects';
export const AGENCY_HUB_PROJECT_MEMBERS_QUERY = 'agency-hub-project-members';
